import { createThunk } from 'utils/createThunk';
import * as backendAPI from 'api/backendAPI/models';
import types from 'constants/actionTypes';

export const setSelectedTemplateId = templateId => ({
  type: types.SET_SELECTED_TEMPLATE_ID,
  payload: templateId,
});

export const setDuplicateTemplateId = templateId => ({
  type: types.SET_DUPLICATE_TEMPLATE_ID,
  payload: templateId,
});

export const setSwappedTemplateId = templateId => ({
  type: types.SET_SWAPPED_TEMPLATE_ID,
  payload: templateId,
});

export const fetchTemplateDetailImages = createThunk({
  apiCall: backendAPI.getTemplateDetailImages,
  type: types.GET_TEMPLATE_DETAIL_IMAGES_REQUEST,
});
